class ShopifyImageService {
  size(image, width, height) {
    if (typeof image !== 'string') {
      return image;
    }

    try {
      let regex = /_\d+\x\d+\./gm;
      let res = regex.exec(image);

      if (res) {
        // replace size
        regex = /\..{3,4}\?v=/gm;
        const res2 = regex.exec(image);

        return image.substring(0, res2.index - res2[0].length - 1) + `_${width}x${height}` + image.substring(res.index + res[0].length - 1);
      } else {
        // add size
        regex = /\..{3,4}\?v=/gm;
        res = regex.exec(image);

        return image.substring(0, res.index) + `_${width}x${height}` + image.substring(res.index, image.length);
      }
    } catch (error) {
      console.warn('Failed to set size to shopify image url', error);
      return image;
    }
  }
}

export default new ShopifyImageService();
